<div class="fp-shell">

  <!-- Header -->
  <div class="fp-header">
    <div class="fp-header-content">
      <div class="fp-title">
        <mat-icon>tune</mat-icon>
        <span>Filtros de búsqueda</span>
      </div>

      <button type="button" class="fp-close-btn" (click)="close()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <form class="fp-body" *ngIf="form" [formGroup]="form">

    <div class="fp-row">
      <label class="fp-label">Persona</label>
      <mat-form-field appearance="outline" class="fp-field">
        <input matInput formControlName="personalName" placeholder="Nombre de la persona">
      </mat-form-field>
    </div>

    <div class="fp-row">
      <label class="fp-label">Documento</label>
      <mat-form-field appearance="outline" class="fp-field">
        <input matInput formControlName="personalDocNum" placeholder="Número de documento">
      </mat-form-field>
    </div>

    <div class="fp-row">
      <label class="fp-label">Empresa</label>
      <mat-form-field appearance="outline" class="fp-field">
        <mat-select formControlName="employerName" placeholder="Todas las empresas">
          <mat-option [value]="null">Todas las empresas</mat-option>
          <mat-option *ngFor="let e of employerOptions" [value]="e">{{ e }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="fp-row">
      <label class="fp-label">Categoría</label>
      <mat-form-field appearance="outline" class="fp-field">
        <mat-select formControlName="categoryType" placeholder="Todas las categorías">
          <mat-option [value]="null">Todas las categorías</mat-option>
          <mat-option *ngFor="let c of categoryOptions" [value]="c">{{ categoryLabel(c) }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="fp-row">
      <label class="fp-label">Función</label>
      <mat-form-field appearance="outline" class="fp-field">
        <mat-select formControlName="functionValue" placeholder="Todas las funciones">
          <mat-option [value]="null">Todas las funciones</mat-option>
          <mat-option *ngFor="let f of functionOptions" [value]="f">{{ f }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="fp-row">
      <label class="fp-label">Tipo de registro</label>
      <mat-form-field appearance="outline" class="fp-field">
        <mat-select formControlName="eventType" placeholder="Todos los tipos">
          <mat-option [value]="null">Todos los tipos</mat-option>
          <mat-option *ngFor="let o of eventTypeOptions" [value]="o.value">{{ o.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="fp-row">
      <label class="fp-label">Requisitos de acceso</label>
      <mat-form-field appearance="outline" class="fp-field">
        <mat-select formControlName="requirementStatus">
          <mat-option value="ALL">Todos</mat-option>
          <mat-option value="CUMPLE">Cumplen todos</mat-option>
          <mat-option value="NO_CUMPLE">No cumplen algún requisito</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="fp-row">
      <label class="fp-label">Cambio de foto</label>
      <mat-form-field appearance="outline" class="fp-field">
        <mat-select formControlName="photoChangeStatus">
          <mat-option value="ALL">Todos</mat-option>
          <mat-option value="YES">Solicitado</mat-option>
          <mat-option value="NO">No solicitado</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

  </form>

  <!-- Footer -->
  <div class="fp-footer">
    <button type="button" class="fp-btn-clear" (click)="clear()">Limpiar filtros</button>
    <button type="button" class="fp-btn-apply" (click)="apply()">Aplicar filtros</button>
  </div>

</div>
